'use strict';

angular.module('imagetrend.components')
    .controller('FileUploadModalController', ['$scope', '$uibModalInstance', 'Upload', 'file_content', 'FileTypes', 'file_upload_existing_docs', 'parameters', '$rootScope', 'question_id', function ($scope, $uibModalInstance, Upload, file_content, FileTypes, file_upload_existing_docs, parameters, $rootScope, question_id) {

        $scope.vm = {
            file: null,
            file_content: file_content
        }
        $scope.uploading = false;
        $scope.working = false;
        $scope.file_upload_existing_docs = file_upload_existing_docs;
        $scope.existingFileSelected = false;
        $scope.newFileSelected = false;
        $scope.document_id = null;
        $scope.user_id = $rootScope.userID;
        $scope.validationText = false;

        if (parameters && parameters.user_id) {
            $scope.user_id = parameters.user_id
        }
        FileTypes.getByEnterprise().then(function(data) {
            if (data != null && data.length > 0) {
                $scope.extensions = data.toString();
            } else {
                $scope.extensions = "'*'";
            }
            
        });

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            $scope.newFileSelected = file != null;
            $scope.working = true;
            Upload.base64DataUrl(file).then(function (content) {
                $scope.vm.file_content = content;
                $scope.working = false;
                $scope.uploading = false;
            })
        }

        $scope.existingFileUpdated = function (document_id) {
            $scope.existingFileSelected = document_id != null;
            $scope.document_id = document_id;
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.documentParameters = {
            user_id: $scope.user_id,
            question_id: question_id
        }

        $scope.save = function () {
            if ($scope.vm.file != null && $scope.newFileSelected) {
                $uibModalInstance.close({
                    file_name: $scope.vm.file.name,
                    file_content: $scope.vm.file_content
                });
            }
            else if ($scope.document_id != null && $scope.existingFileSelected) {
                $uibModalInstance.close({
                    document_id: $scope.document_id
                });
            }
            else if ($scope.file_upload_existing_docs == true)
            {
                $scope.validationText = true;
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;